import { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useFirebase } from "../../../contexts/FirebaseContext";
import "./ProfileDropdown.css";

import { ReactComponent as UserIcon } from '../../../assets/icons/svg/user-svgrepo-com.svg';

export default function ProfileDropdown({ auth, currentGame = 'mk8dx' }) {
    const [isOpen, setIsOpen] = useState(false);
    const [displayName, setDisplayName] = useState(null);
    const { firestore } = useFirebase();
    const dropdownRef = useRef(null);
    const location = useLocation();

    // Determine current game from path if not explicitly passed
    const game = currentGame || (location.pathname.startsWith('/mk8dx') ? 'mk8dx' : 'world');

    // Fetch displayName from Firestore
    useEffect(() => {
        const fetchDisplayName = async () => {
            if (auth?.currentUser?.uid) {
                const userDoc = await getDoc(doc(firestore, "users", auth.currentUser.uid));
                if (userDoc.exists()) {
                    setDisplayName(userDoc.data().displayName);
                }
            }
        };
        fetchDisplayName();
    }, [auth?.currentUser?.uid, firestore]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSignOut = async () => {
        await signOut(auth);
        setIsOpen(false);
        window.location.reload();
    };

    if (!auth.currentUser?.uid) {
        return <Link to={`/signin?game=${game}`} className="signin-link">Sign In</Link>;
    }

    return (
        <div className="profile-dropdown" ref={dropdownRef}>
            <button 
                className="profile-button" 
                onClick={() => setIsOpen(!isOpen)}
                aria-expanded={isOpen}
                aria-haspopup="true"
            >
                <UserIcon className="profile-icon"/>
                {/* <span className="profile-username">{auth.currentUser.displayName || "Profile"}</span> */}
                <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>
            </button>
            
            {isOpen && displayName && (
                <div className="dropdown-menu">
                    <Link 
                        to={`/profile/${displayName}`} 
                        className="dropdown-item"
                        onClick={() => setIsOpen(false)}
                    >
                        My Profile
                    </Link>
                    <Link
                        to={`/profile/${displayName}/edit`}
                        className="dropdown-item"
                        onClick={() => setIsOpen(false)}
                    >
                        Edit Profile
                    </Link>
                    <button 
                        onClick={handleSignOut} 
                        className="dropdown-item signout-button"
                    >
                        Sign Out
                    </button>
                </div>
            )}
        </div>
    );
}
